import React from 'react';
import { Form, Input, Spin } from 'antd';
import { Button } from 'react-bootstrap';
import { analytics, axius, func, types } from 'utils';
import { _update } from '../_Store';

interface Props {
	title?: string;
	channel: types.CodeChannels;
	sendOtp: boolean;
	username: string;

	onSuccess: () => void;
}
const Verify = (props: Props) => {
	const { sendOtp, channel } = props;

	const [form] = Form.useForm();

	const [count, setCount] = React.useState(0);
	const [errMsg, setErrMsg] = React.useState('');
	const [consent, setConsent] = React.useState(false);
	const [submitting, setSubmitting] = React.useState(false);

	const username =
		channel === types.CodeChannels.SMS
			? func.format.phoneNumber(props.username)?.split(' ').join('')
			: props.username;

	React.useEffect(() => {
		if (sendOtp) {
			setConsent(true);
		} else {
			startTimer();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const startTimer = () => {
		const timer = setInterval(() => {
			setCount((prevCount) => prevCount + 1);
		}, 1000);
		return () => {
			clearInterval(timer);
		};
	};

	const sendCode = async () => {
		setErrMsg('');
		setSubmitting(true);
		axius.post('auth/otp', { username, channel }).then((res) => {
			setSubmitting(false);
			if (res.status === 201) {
				setCount(0);
				startTimer();
				setConsent(false);
			} else {
				setErrMsg(
					res.message ||
						'Failed to send OTP. Please check your number and retry'
				);
			}
		});
	};

	const submit = (v: any) => {
		setErrMsg('');
		setSubmitting(true);
		axius.put('auth/otp', { ...v, username, channel }).then((res) => {
			setSubmitting(false);
			if (res.status === 200) {
				if (res.data) {
					const kyc = func.checkKYC(res.data);
					_update.auth('user', res.data);
					if (channel === types.CodeChannels.SMS && kyc.phone) {
						analytics.trackEvent(analytics.eventTypes.VERIFIED_PHONE);
					}
					if (channel === types.CodeChannels.EMAIL && kyc.email) {
						analytics.trackEvent(analytics.eventTypes.VERIFIED_EMAIL);
					}
				}
				props.onSuccess && props.onSuccess();
			} else {
				setErrMsg(res.message || 'Verification failed.');
			}
		});
	};

	const usernameIsEmail = Boolean(channel === types.CodeChannels.EMAIL);

	return (
		<div className="ph-no-capture">
			<Spin
				spinning={submitting}
				indicator={
					<span>
						<i className="fa fa-spin fa-circle-notch" />
					</span>
				}
			>
				<h4 className="primary text-center">
					<b>Verification</b>
				</h4>
				{consent ? (
					<>
						{errMsg && (
							<div className="alert alert-danger text-center">{errMsg}</div>
						)}
						<div className="text-muted text-center">
							{usernameIsEmail ? 'Email' : 'Phone number'} verification required
							for account security. <br />A 6 digit code will be sent to{' '}
							{usernameIsEmail
								? props.username
								: func.format.phoneNumber(props.username)}
							.
						</div>
						<p>&nbsp;</p>
						<Button
							type="submit"
							variant="secondary btn-block btn-md"
							onClick={sendCode}
						>
							Send code
						</Button>
					</>
				) : (
					<>
						<div className="text-muted">
							Enter the code sent to{' '}
							{usernameIsEmail
								? props.username
								: func.format.phoneNumber(props.username)}
							.
						</div>
						<div>&nbsp;</div>

						{errMsg && (
							<div className="alert alert-danger text-center">{errMsg}</div>
						)}

						<Form form={form} layout="vertical" onFinish={submit}>
							<Form.Item
								name="code"
								rules={[{ required: true, message: 'Code is required' }]}
							>
								<Input
									type="number"
									size="large"
									className="text-center"
									placeholder="• • • • • •"
									style={{ letterSpacing: 10 }}
								/>
							</Form.Item>
							<div>&nbsp;</div>

							<Button type="submit" variant="secondary btn-block btn-md">
								Verify &amp; Continue
							</Button>
							<div>&nbsp;</div>

							<div className="text-center">
								Didn't get the code?{' '}
								{count < 60 ? (
									`Resend in ${60 - count} secs`
								) : (
									<b onClick={sendCode}>RESEND NOW</b>
								)}
								.
							</div>
						</Form>
					</>
				)}
			</Spin>
		</div>
	);
};

export default Verify;
